import style from "./client.module.css"
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useForm, Controller } from 'react-hook-form';
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavBar from "../../../components/NavBar/NavBar";
import * as actions from "../../../redux/actions"
import {url, urlFront} from "../../../App";
import { ALERT_SESSION } from "../../../redux/action-types";
import AlertSession from "../../../components/AlertSession/AlertSession";


const UpdateClient = (props) => {
    const {id} = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {handleSubmit, control, formState: {errors}, trigger, reset, watch} = useForm()
    let allClients = useSelector((state) => state.allClients)
    let actualClient = allClients.filter((client) => client.id === parseInt(id));
    let dataClient = actualClient[0]
    const allCitys = useSelector((state) => state.allCitys)
    const allDepartments = useSelector((state) => state.allDepartments)
    const alertSession = useSelector((state) => state.alertSession)
    const [filterCity, setFilterCity] = useState([])
    useEffect(()=> {
        if (!allDepartments) {
            dispatch(actions.allDepartments())
        }
    }, [])
    const handleChange = (e, allCitys) => {
        const departmentIdValue = e.target.value
        const citysById = allCitys.filter((city) => city.departmentId === parseInt(departmentIdValue))
        setFilterCity(citysById)
    }
    const [confirmRegistro, setConfirmRegistro] = useState(null);
    const [formDisabled, setFormDisabled] = useState(false);
    const onSubmit = async (data) => {
        data.id = id
        try {
            setFormDisabled(true);
            const config = {
                method: 'patch',
                url: `${url}/clients/update/${data.id}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                data: data
            };
            const response = await axios(config)
            if (response.data) {
                if (response.data.success === true) {
                    setConfirmRegistro(true)
                }
                else {
                    setConfirmRegistro(false)
                }
            }
            setTimeout(()=> {navigate("/data/client");reset()}, 2000)
        } catch (error) {
          console.error("Error al crear usuario:", error);
          setFormDisabled(false);
          setConfirmRegistro(false)
          reset()

          if(error.response.status === 401) {
            dispatch({
                type: ALERT_SESSION,
                payload: true
            })

            setTimeout(() => {
                localStorage.clear('globalState')
                window.location.replace(urlFront)
            }, [3000])
            
          }  
        }
      };
      useEffect(() => {
        dispatch(actions.allClients())
      }, [])
    if (!dataClient) {
        navigate("/data/client")
    }
    return (
        <div className={style.divContenedor}>
            <NavBar/>
        <div className={style.contenedor}>
        {alertSession && <AlertSession text1="Su sesión ha vencido" text2="Por favor, vuelva a iniciar sesión" disabledBtn={false}/>}
          <div className={style.divComplementario}>
            <h1 className={style.titulo}>Clientes</h1>
            <h4 className={style.subtitulo}>Actualizar cliente</h4>
          </div>
            <div className={style.newUser}>
                    <div>
                        <form className={style.form} onSubmit={handleSubmit(onSubmit)}>
                            <div className={style.divDatos}>
                                <div className={style.divCampo}>
                                    <label className={style.label} htmlFor="name">Cliente</label>
                                    <div className={style.divInput}>
                                        <Controller name="name"
                                        control={control}
                                        defaultValue={dataClient ? dataClient.name : ""}
                                        rules={{ required: 'Este campo es obligatorio', maxLength: {value: 30,message: 'Máximo 30 caracteres'}, minLength: {value: 2,message: 'Minímo 2 caracteres'}} }
                                        render={({ field }) => (
                                        <input className={style.input} type="text" {...field} value={field.value} onChange={(e) => {field.onChange(e); trigger("name"); }}/>)}/>
                                        <div className={style.errorMenssage}>
                                            {errors.name && <p className={style.errorText}>{errors.name.message}</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className={style.divCampo}>
                                    <label className={style.label} htmlFor="nit">NIT</label>
                                    <div className={style.divInput}>
                                        <Controller name="nit"
                                        control={control}
                                        defaultValue={dataClient ? dataClient.nit:""}
                                        rules={{ required: 'Este campo es obligatorio', maxLength: {value: 30,message: 'Máximo 30 caracteres'}, minLength: {value: 4,message: 'Minímo 4 caracteres'}} }
                                        render={({ field }) => (
                                        <input className={style.input} type="text" {...field} value={field.value} onChange={(e) => {field.onChange(e); trigger("nit"); }}/>)}/>
                                        <div className={style.errorMenssage}>
                                            {errors.nit && <p className={style.errorText}>{errors.nit.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className={style.divCampo}>
                                    <label className={style.label} htmlFor="departmentId"> Departamento </label>
                                    <div className={style.divInput}>
                                        <Controller name="departmentId"
                                        control={control}
                                        defaultValue={""}
                                        rules={{ required: 'Seleccione el depertamento' }}
                                        render={({ field }) => (
                                    <select className={style.select} {...field} onChange={(e) => {field.onChange(e); trigger("departmentId"); handleChange(e, allCitys) }}> 
                                        <option value="" disabled> Seleccione el departamento </option>
                                        {allDepartments !== undefined ? allDepartments.map((department) => (
                                        <option key={department.id} value={department.id}>
                                            {department.department}</option>)):null}
                                        </select>)} />
                                        <div className={style.errorMenssage}>
                                            {errors.departmentId && <p className={style.errorText}>{errors.departmentId.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className={style.divCampo}>
                                    <label className={style.label} htmlFor="cityId"> Ciudad </label>
                                    <div className={style.divInput}>
                                        <Controller name="cityId"
                                        control={control}
                                        defaultValue={""}
                                        rules={{ required: 'Seleccione la ciudad' }}
                                        render={({ field }) => (
                                    <select className={style.select} {...field} onChange={(e) => {field.onChange(e); trigger("cityId"); }}> 
                                        <option value="" disabled> Seleccione la ciudad </option>
                                        {filterCity.map((city) => (
                                        <option key={city.id} value={city.id}>
                                            {city.city}</option>))}
                                        </select>)} />
                                    </div>
                                </div>
                                <div className={style.divCampo}>
                                    <label className={style.label} htmlFor="telefonoPrincipal">Teléfono</label>
                                    <div className={style.divInput}>
                                        <Controller name="telefonoPrincipal"
                                        control={control}
                                        defaultValue={dataClient ? dataClient.telefonoPrincipal:""}
                                        rules={{ required: 'Este campo es obligatorio', maxLength: {value: 30,message: 'Máximo 30 caracteres'}, minLength: {value: 4,message: 'El Minímo 4 caracteres'}} }
                                        render={({ field }) => (
                                        <input className={style.input} type="text" {...field} onChange={(e) => {field.onChange(e); trigger("telefonoPrincipal"); }}/>)}/>
                                        <div className={style.errorMenssage}>
                                            {errors.telefonoPrincipal && <p className={style.errorText}>{errors.telefonoPrincipal.message}</p>}
                                        </div>
                                    </div>
                                </div>
                        <div className={style.divCampo}>
                            <label className={style.label} htmlFor="emailPrincipal"> Correo electronico </label>
                            <div className={style.divInput}>
                                <Controller name="emailPrincipal"
                                control={control}
                                defaultValue={dataClient ? dataClient.emailPrincipal:""}
                                rules={{
                                    required: 'Este campo es obligatorio',
                                    pattern: {
                                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                      message: 'Ingrese un correo válido',
                                    },
                                }}
                                render={({ field }) => (
                                    <input className={style.input} type="emailPrincipal" {...field} onChange={(e) => {field.onChange(e); trigger("email")}}/>)}/>
                                <div className={style.errorMenssage}>
                                    {errors.emailPrincipal && <p className={style.errorText}>{errors.emailPrincipal.message}</p>}
                                </div>
                            </div>
                        </div>
                        </div>
                        <div>
                            <button type="submit" className={style.formbutton} disabled={formDisabled} > Actualizar cliente </button>
                            {confirmRegistro === true ? (<><p className={style.positivo}>Cliente actualizado con exito</p></>):(confirmRegistro === false ? (<><p className={style.negativo} > No se pudo actualizar, vuelve a intentarlo</p></>):(null))}
                        </div>
                        <Link to="/data">
                            <button type="button" className={style.backbutton}>Volver</button>
                        </Link>
                        </form>
                    </div>
            </div>
        </div>
        </div>
      );
}

export default UpdateClient
